import Raven from 'raven-js';
import { evaluateInAppRpc } from '../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { rpcClient } from '../../rpcClient';
export const fetchPurchaseMotions = ({
  productApiNames,
  purchaseMotionLocation
}) => {
  const locations = [purchaseMotionLocation];
  const purchaseMotionByProductApiName = {};
  for (const productApiName of productApiNames) {
    purchaseMotionByProductApiName[productApiName] = 'TALK_TO_SALES';
  }
  let promiseError = undefined;
  return rpcClient.call(evaluateInAppRpc, {
    request: {
      productApiNames,
      locations
    }
  }).then(response => {
    for (const [productApiName, purchaseMotionsByPriority] of Object.entries(response.purchaseMotionsMapping.productsByLocationString[purchaseMotionLocation].purchaseMotionsByProductApiName)) {
      purchaseMotionByProductApiName[productApiName] = purchaseMotionsByPriority.purchaseMotions[0];
    }
  }, error => {
    promiseError = error;
    Raven.captureException(new Error(error.message, {
      cause: error
    }), {
      extra: {
        productApiNames,
        locations
      }
    });
  }).catch(error => {
    promiseError = error;
    Raven.captureException(new Error('fetchPurchaseMotions: Promise successfully resolved but the catch block was triggered', {
      cause: error
    }), {
      extra: {
        productApiNames,
        locations
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return purchaseMotionByProductApiName;
  });
};